module.exports = __webpack_public_path__ + "media/components/slider/s5-8d471569818d4a1594df8b8b91055294.jpg";